$(document).ready(function () {
  let p = $('body').attr('p');
  if (
    p === 'admin_organizers' ||
    p === 'dealer_organizers' ||
    p === 'seller_organizers' ||
    p === 'admin_organizer_setting'
  ) {
    let config_option_ajax_lock = false;

    $(document).on('submit', '#config-option-organizer-form', function (e) {
      e.preventDefault();

      if (!config_option_ajax_lock) {
        const submitBtn = $('#config-option-organizer-form-button');
        const buttonText = submitBtn.html();
        submitBtn.prop('disabled', true);
        submitBtn.html('<div class="loader"></div>');

        config_option_ajax_lock = true;
        $('#config-option-error-container').html('');

        $.ajax({
          type: 'POST',
          url: '/ajax/admin_config_option/update',
          data: {
            serialized_post: $(this).serialize(),
          },
        })
          .done(function (data) {
            if (data === true) {
              popupAlert();
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              const errorHtml = getAlertHtml(
                data.responseJSON.error_message,
                'danger'
              );
              $('#config-option-error-container').html(errorHtml);
            }

            config_option_ajax_lock = false;
          })
          .always(function () {
            config_option_ajax_lock = false;
            submitBtn.prop('disabled', false);
            submitBtn.html(buttonText);
          });
      }
    });

    $(document).on('change', '.config-option-radio', function () {
      var $radio = $(this);
      var selectedValue = $radio.val();
      var configIdentifier = $radio.attr('name');

      // Find all child input wrappers belonging to this radio group
      $('[data-parent-config-identifier="' + configIdentifier + '"]').each(
        function () {
          var $childWrapper = $(this);
          var ownerRadioValue = $childWrapper.data('radio-value');

          if (ownerRadioValue === selectedValue) {
            $childWrapper.removeClass('d-none');
          } else {
            $childWrapper.addClass('d-none');
          }
          showInvoicePaymentCheckbox();
        }
      );
    });

    // Show child inputs (e.g. ticket sales web address) only while their parent switch is on
    $(document).on(
      'change',
      '#config-option-organizer-form .config-option-checkbox',
      function () {
        $(
          '[data-parent-config-identifier="' + $(this).attr('name') + '"]'
        ).toggleClass('d-none', !$(this).is(':checked'));
      }
    );

    function showInvoicePaymentCheckbox() {
      if ($('.config-option-radio[value="tripletex"]').is(':checked')) {
        $('.triple-tex-invoice-payement-section').removeClass('d-none');
      } else {
        $('.triple-tex-invoice-payement-section').addClass('d-none');
      }
    }
    showInvoicePaymentCheckbox();
  }
});
